import { render, staticRenderFns } from "./InlineVisionboardCard.vue?vue&type=template&id=3bf27932&"
import script from "./InlineVisionboardCard.vue?vue&type=script&lang=js&"
export * from "./InlineVisionboardCard.vue?vue&type=script&lang=js&"
import style0 from "./InlineVisionboardCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports